import { memo, useState } from 'react';
//Local files
import { Content, LeftPanel, NavList, Root } from './Builder.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import NavItem from 'components/Documents/Builder/NavItem/NavItem';
import TextIcon from '@mui/icons-material/TextFieldsOutlined';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import GestureIcon from '@mui/icons-material/Gesture';
import DocumentContent from 'components/Documents/Builder/DocumentContent/DocumentContent';
import GhostElement from 'components/Documents/Builder/Element/Common/GhostElement/GhostElement';
import { elementableTypes } from 'helpers/constants';

const { DATE, TEXT, SIGNATURE } = elementableTypes;

const DocBuilder = ({ file, pages, elements, setElements, signatureElement = false }) => {
  const [newElementType, setNewFieldType] = useState(null);

  return (
    <Root>
      <GhostElement { ...{newElementType}} />
      <LeftPanel>
        <NavList>
          <NavItem
            id={TEXT}
            icon={<TextIcon />}
            label='Text'
            active={newElementType?.target?.id === TEXT}
            onDragStart={(e) => setNewFieldType(e)}
          />
          <NavItem
            id={DATE}
            icon={<CalendarIcon />}
            label='Date'
            active={newElementType?.target?.id === DATE}
            onDragStart={(e) => setNewFieldType(e)}
          />
          {signatureElement && <NavItem
            id={SIGNATURE}
            icon={<GestureIcon />}
            label='Signature'
            active={newElementType?.target?.id === SIGNATURE}
            onDragStart={(e) => setNewFieldType(e)}
          />}
        </NavList>
      </LeftPanel>
      <Content>
        <DocumentContent {...{ file, pages, elements, onElements: setElements, onNewFieldType: setNewFieldType }} />
      </Content>
    </Root>
  )
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <DocBuilder {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);